import { RootState } from '@/store/types';
import { Module, GetterTree, MutationTree, ActionTree } from 'vuex';
import { Clipboard, ClipboardState, ClipboardInfo } from '@/store/modules/clipboard/types';
import { ClipboardAPI, GetClipboardReq, GetClipbordByTime } from '@/api/clipboard';
import { formToJSON } from 'axios';
import { ClipboardPagination } from './types';


export const moduleName = "clipboard";
export enum ClipboardGetters {
    getClipboardList = "GET_CLIPBOARD_LIST",
    getLoading = "GET_LOADING",
    getPagination = "GET_PAGINATION",
    getIsAllLoaded = "GET_IS_ALL_LOADED",
    getTimeLineSlice = "GET_TIME_LINE_SLICE",
}

export enum ClipboardMutations {
    setClipboardList = "SET_CLIPBOARD_LIST",
    setLoading = "SET_LOADING",
    setPaginations = "SET_PAGINATION",
    setIsAllLoaded = "SET_IS_ALL_LOADED",
    setTimeLineSlice = "SET_TIME_LINE_SLICE",
    resetAll = "RESET_ALL",
}

export enum ClipboardActions {
    asyncGetClipboardList = "ASYNC_GET_CLIPBOARD_LIST",
    asyncGetClipboardListByTime = "ASYNC_GET_CLIPBOARD_LIST_BY_TIME",
    asyncGetTimeLine = "ASYNC_GET_TIME_LINE",
}
const defaultPagination: ClipboardPagination = {
    pageNum: 1,
    pageSize: 10,
}

const state: ClipboardState = {
    clipboardList: [],
    isLoading: false,
    isAllLoaded: false,
    pagination: defaultPagination,
    timeLineSlice: [],
}

export const getters: GetterTree<ClipboardState, RootState> = {
    [ClipboardGetters.getClipboardList](state): Clipboard[] {
        return state.clipboardList;
    },
    [ClipboardGetters.getLoading](state): boolean {
        return state.isLoading;
    },
    [ClipboardGetters.getIsAllLoaded](state): boolean {
        return state.isAllLoaded;
    },
    [ClipboardGetters.getPagination](state): ClipboardPagination {
        return state.pagination;
    },
    [ClipboardGetters.getTimeLineSlice](state): string[] {
        return state.timeLineSlice;
    },
}

const mutations: MutationTree<ClipboardState> = {
    [ClipboardMutations.setClipboardList](state, payload: Clipboard[]): void {
        state.clipboardList = state.clipboardList.concat(payload);
    },
    [ClipboardMutations.setLoading](state, payload: boolean): void {
        state.isLoading = payload;
    },
    [ClipboardMutations.setIsAllLoaded](state, payload: boolean): void {
        state.isAllLoaded = payload;
    },
    [ClipboardMutations.setPaginations](state, payload: ClipboardPagination): void {
        state.pagination = payload;
    },
    [ClipboardMutations.setTimeLineSlice](state, payload: string[]): void {
        state.timeLineSlice = payload;
    },
    [ClipboardMutations.resetAll](state): void {
        state.clipboardList = [];
        state.pagination = defaultPagination;
        state.isAllLoaded = false;
    },
}

const actions: ActionTree<ClipboardState, RootState> = {
    async [ClipboardActions.asyncGetClipboardList]({ commit, getters }, { projId, uid }: { projId: string, uid: string }): Promise<void> {
        try {
            commit(ClipboardMutations.setLoading, true);
            const pagination = getters[ClipboardGetters.getPagination]
            const reqParams: GetClipboardReq = { projId: projId, uid: uid, ...pagination };

            const res = await ClipboardAPI.getClipboardListByUid(reqParams);
            if (res.length !== 0) {
                commit(ClipboardMutations.setClipboardList, res);
                if (res.length < state.pagination.pageSize) {
                    commit(ClipboardMutations.setIsAllLoaded, true)
                }
            } else {
                commit(ClipboardMutations.setIsAllLoaded, true)
            }
            commit(ClipboardMutations.setPaginations, { ...pagination, pageNum: pagination.pageNum + 1 });
        } catch (err) {
            console.log(err);
        } finally {
            commit(ClipboardMutations.setLoading, false);
        }
    },
    async [ClipboardActions.asyncGetClipboardListByTime]({ commit, getters }, { projId, uid, time }: { projId: string, uid: string, time: string }): Promise<void> {
        try {
            commit(ClipboardMutations.setLoading, true);
            const pagination = getters[ClipboardGetters.getPagination]
            const reqParams: GetClipbordByTime = { projId: projId, uid: uid, time: time, ...pagination };

            const res = await ClipboardAPI.getClipboardListByUidAndTime(reqParams);
            if (res.length !== 0) {
                commit(ClipboardMutations.setClipboardList, res);
                if (res.length < state.pagination.pageSize) {
                    commit(ClipboardMutations.setIsAllLoaded, true)
                }
            } else {
                commit(ClipboardMutations.setIsAllLoaded, true)
            }
            commit(ClipboardMutations.setPaginations, { ...pagination, pageNum: pagination.pageNum + 1 });
        } catch (err) {
            console.log(err);
        } finally {
            commit(ClipboardMutations.setLoading, false);
        }
    },
    async [ClipboardActions.asyncGetTimeLine]({ commit, getters }, { projId, uid }: { projId: string, uid: string }): Promise<void> {
        try {
            commit(ClipboardMutations.setLoading, true);
            const res = await ClipboardAPI.getTimeLineByUid(projId, uid);
            const timeLine: string[] = []

            if (res.length !== 0) {
                for (let i = 0; i < res.length; i++) {
                    timeLine.push(res[i].created)
                }
            }
            commit(ClipboardMutations.setTimeLineSlice, timeLine)

        } catch (err) {
            console.log(err);
        } finally {
            commit(ClipboardMutations.setLoading, false);
        }
    },
}

export const clipboard: Module<ClipboardState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
